import { ErrorMessage, useFormikContext } from 'formik'
import React from 'react'

function TextArea({ label, name, placeholder, value, required, readOnly }) {
  const formik = useFormikContext()

  return (
    <>
      <label for={name} class='block mb-2 text-sm font-medium text-gray-900'>
        {label}
        {required ? ' *' : ''}
      </label>
      <textarea
        id={name}
        rows='4'
        class={`block p-2.5 w-full text-sm focus:outline-none text-gray-900 bg-gray-50 rounded-lg border border-gray-300 ${
          readOnly
            ? ''
            : ' focus:ring-blue-500 focus:border-blue-500 focus:bg-white'
        }`}
        placeholder={placeholder}
        value={value}
        {...formik?.getFieldProps(name)}
        readOnly={readOnly}
      ></textarea>
      {name && (
        <ErrorMessage
          name={name}
          component={'div'}
          className='text-xs text-red-500 font-light mt-1'
        />
      )}
    </>
  )
}

export default TextArea
